import HipaaModal from './HipaaModal'

export default HipaaModal
